// extracted by mini-css-extract-plugin
export default {"mansaQuery":"mansa-query_mansaQuery__M1GVd","mansaQueryIcon":"mansa-query_mansaQueryIcon__yvvB9","items":"mansa-query_items__j3ZzO","item":"mansa-query_item__5EsKX"};